/* eslint-disable @typescript-eslint/naming-convention */
import { CashFlow } from 'src/app/domain/company-performance/cash-flow/dto/CashFlow';
import { formats, getCell, PartialCell, withCellStyles } from '../../utils';
import { CellStyle } from 'xlsx-js-style';
import { Rows } from '../../interfaces';
import { DataType } from 'src/app/domain/excel/utils/cells';

export const getPreparedData = (data: CashFlow[], headers: string[]): Rows => {
  const newData: Rows = [];
  newData.push(headers);

  const rows = getManyRows(data, headers);
  newData.push(...rows);
  const row = [];
  const mapped = getIrrMapping(data);
  for (const header of headers) {
    row.push(withCellStyles(mapped[header] as DataType, bold));
  }
  newData.push(row);
  return newData;
};

export const getManyRows = (cashFlows: CashFlow[], headers: string[]): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = cashFlows.map((d) => getNewMapping(d));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of headers) {
      if (header === 'Company') {
        row.push(withCellStyles(mapped[header], leftBold));
      } else {
        row.push(mapped[header]);
      }
    }
    rows.push(row);
  }
  return rows;
};


const generateIrrFormula = (cashFlows: CashFlow[]): string => {
  return `=XIRR(C2:C${cashFlows.length + 1},B2:B${cashFlows.length + 1},IF(SUM(C2:C${cashFlows.length + 1})>0,ABS(SUMIF(C2:C${cashFlows.length + 1},">"&0,C2:C${cashFlows.length + 1})/SUMIF(C2:C${cashFlows.length + 1},"<"&0,C2:C${cashFlows.length + 1})),-ABS(SUMIF(C2:C${cashFlows.length + 1},">"&0,C2:C${cashFlows.length + 1})/SUMIF(C2:C${cashFlows.length + 1},"<"&0,C2:C${cashFlows.length + 1}))))`;
};


export const getIrrMapping = (cashFlows: CashFlow[]): MappedCashFlowRow => {
  return {
    Company: '',
    'Transaction date': cashFlows[cashFlows.length - 1].transactionDate,
    Amount: getCell({
      f: generateIrrFormula(cashFlows),
      z: formats.percents,
      t: 'n',
    }),
    'Round name': '',
    'Transaction type': ' Gross irr',
  };
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const getNewMapping = (c: CashFlow): MappedCashFlowRow => {
  const name = c.rounds?.length ? c.rounds[0].name : '';
  return {
    Company: c.companyName,
    'Transaction date': c.transactionDate,
    Amount: getCell({ v: c.amount, z: formats.thousandsSeparator, t: 'n' }),
    'Transaction type': c.type,
    'Round name': name,
    Comment: c.comment,
  };
};

const leftBold: CellStyle = {
  alignment: { horizontal: 'left' },
  font: { bold: true },
};

const bold: CellStyle = {
  font: { bold: true },
};

interface MappedCashFlowRow {
  'Company': string;
  'Transaction date': Date;
  'Amount': PartialCell;
  'Transaction type': string;

  // optional, because they are not used in the total row
  'Round name'?: string;
  'Comment'?: string;
}
